import { Form } from "@redriver/cinnamon-mui";
import { enquiryScopeStatusLookup } from "modules/lookups";

const EnquiryScopeStatusDropdown = (props) => (
  <Form.Dropdown {...props} lookup={enquiryScopeStatusLookup} />
);

export default EnquiryScopeStatusDropdown;
